import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import ButtonBar from "../../core/ButtonBar/ButtonBar";
import ComponentHeader from "../../core/ComponentHeader";
import DropDown from "../../core/DropDown";
import SubmitControl from "../../core/SubmitControl";
import Tag from "../../core/Tag";
import KnowledgeSourceLookup from "../Lookups/KnowledgeSourceLookup";
import KnowledgeTypeLookup from "../Lookups/KnowledgeTypeLookup";
import ClassificationSelection from "../page/ClassificationSelection";

const AdvancedSearch = props => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <div>
          <ComponentHeader title={labels.advancedSearch} showBackButton />
        </div>
        <div className="bordered_bottom_rounded">
          <Form.Label className="advanced_search_description">
            <i>{labels.advancedSearchDescription}</i>
          </Form.Label>

          <Form>
            <Form.Group controlId="correctWords">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">
                    {labels.correctWords}
                  </Form.Label>
                </Col>
                <Col>
                  <SubmitControl
                    autoFocus
                    type="text"
                    placeholder={labels.advancedSearchPlaceholder}
                    value={props.advancedSearchParams.correctWords.filterVal}
                    onChange={props.onChange}
                  ></SubmitControl>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="phrases">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">{labels.phrases}</Form.Label>
                </Col>
                <Col>
                  <SubmitControl
                    type="text"
                    placeholder={labels.advancedSearchPlaceholder}
                    value={props.advancedSearchParams.phrases.filterVal}
                    onChange={props.onChange}
                  ></SubmitControl>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="anyWords">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">{labels.anyWords}</Form.Label>
                </Col>
                <Col>
                  <SubmitControl
                    type="text"
                    placeholder={labels.advancedSearchPlaceholder}
                    value={props.advancedSearchParams.anyWords.filterVal}
                    onChange={props.onChange}
                  ></SubmitControl>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="nonWords">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">{labels.nonWords}</Form.Label>
                </Col>
                <Col>
                  <SubmitControl
                    type="text"
                    placeholder={labels.advancedSearchPlaceholder}
                    value={props.advancedSearchParams.nonWords.filterVal}
                    onChange={props.onChange}
                    maxLength=""
                  ></SubmitControl>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="documentSearchQuery">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">
                    {labels.documentsContent}
                  </Form.Label>
                </Col>
                <Col>
                  <SubmitControl
                    type="text"
                    placeholder={labels.searchQueryPlaceholder}
                    value={
                      props.advancedSearchParams.documentSearchQuery.filterVal
                    }
                    onChange={props.onChange}
                    maxLength=""
                  ></SubmitControl>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="extensions">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">{labels.extensions}</Form.Label>
                </Col>
                <Col>
                  <DropDown
                    value={props.advancedSearchParams.extensions.filterVal}
                    options={props.extensions.map(x => ({
                      value: x,
                      label: x.id
                    }))}
                    onChange={props.onChange}
                    targetId={"extensions"}
                    placeholder={labels.extensions}
                    isClearable={true}
                    isMulti={true}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">
                    {labels.knowledgeType}
                  </Form.Label>
                </Col>
                <Col>
                  <KnowledgeTypeLookup
                    onChange={props.onChange}
                    controlId="knowledgeTypes"
                    selected={
                      props.advancedSearchParams.knowledgeTypes.filterVal
                    }
                    messageHandler={props.messageHandler}
                    breadcrumbsHandler={props.breadcrumbsHandler}
                    placeholder={labels.knowledgeType}
                    multiple
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">
                    {labels.knowledgeSource}
                  </Form.Label>
                </Col>
                <Col>
                  <KnowledgeSourceLookup
                    onChange={props.onChange}
                    controlId="knowledgeSources"
                    selected={
                      props.advancedSearchParams.knowledgeSources.filterVal
                    }
                    messageHandler={props.messageHandler}
                    breadcrumbsHandler={props.breadcrumbsHandler}
                    placeholder={labels.knowledgeSource}
                    multiple
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="tags">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">{labels.tags}</Form.Label>
                </Col>
                <Col>
                  <Tag
                    tags={props.advancedSearchParams.tags.filterVal || []}
                    onChange={props.onChange}
                    reload={props.reloadTags}
                    reloaded={props.reloadedTags}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="autoTags">
              <Row>
                <Col sm="2">
                  <Form.Label className="Label">{labels.autoTags}</Form.Label>
                </Col>
                <Col>
                  <Tag
                    controlId="autoTags"
                    tags={props.advancedSearchParams.autoTags.filterVal || []}
                    onChange={props.onChange}
                    reload={props.reloadTags}
                    reloaded={props.reloadedTags}
                  />
                </Col>
              </Row>
            </Form.Group>
            <ClassificationSelection
              setClassificationsOnEntity={props.onSelectClassification}
              messageHandler={props.messageHandler}
              classifications={
                props.advancedSearchParams.classifications.filterVal
              }
              classificationsFilter={props.classificationsFilter}
            />
            <ButtonBar
              onSearch={props.handleAdvancedSearch}
              onSearchReset={props.resetAdvancedSearchParams}
            />
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSearch;
